export const renderTabIndex = (
  radio: string,
  labelText: string,
  radioIndex: number,
  checked?: boolean,
) => {
  if (!radio) {
    if (radioIndex === 0) {
      return 0;
    }
    return -1;
  } else if (radio === labelText || checked) {
    return 0;
  }
  return -1;
};
